import { useMemo } from 'react';
import { useFetch } from '../../hooks/useFetch';
import LoaderPage from '../LoaderPage/LoaderPage';
import Markdown, { MarkdownProps } from './Markdown';

export type MarkdownRemoteProps = Omit<MarkdownProps, 'markdown'> & {
  url: string;
  parser?: (data?: string) => string;
};

export function MarkdownRemote(props: MarkdownRemoteProps) {
  const { url, parser } = props;
  const [data, { isLoading }] = useFetch<string>(url);

  const parsedData = useMemo(() => {
    if (parser) return parser(data);
    return data;
  }, [data]);

  if (isLoading) {
    return (
      <>
        <br />
        <br />
        <br />
        <LoaderPage />
      </>
    );
  }

  return <Markdown {...props} markdown={parsedData} />;
}

export default MarkdownRemote;
